export default __webpack_public_path__ + "i18n/translations/translation-th.5e0cf339.json";